import { chunk } from 'lodash'
import { validation } from 'utils'
import * as Yup from 'yup'
import { setProgress } from 'features/export_import/importExportSlice'
import {
    convertBooleanValue,
    convertStringToList,
    LIMITED_NUMBER_OF_UPLOADED_ITEMS,
} from 'features/export_import/utils'
import { showErrorNotification } from 'features/notifications/notificationsSlice'
// @ts-ignore
import SampleFile from 'features/export_import/sample_files/sample_movie.xlsx'
import {
    ImportDataFormProps, MappedField, SampleDataType
} from 'features/export_import/types'
import { importMovies } from './graphql/mutation'

export const mappedFields: MappedField[] = [
    {
        field: 'externalId', label: 'ID', isRequired: true
    },
    {
        field: 'title', label: 'Title', isRequired: true
    },
    {
        field: 'subtitle', label: 'Subtitle', isRequired: true
    },
    {
        field: 'embeddedUrl', label: 'Video Url', isRequired: true
    },
    {
        field: 'order', label: 'Order'
    },
    {
        field: 'published', label: 'Published'
    },
    {
        field: 'tags', label: 'Tags'
    },
]

export const sampleData: SampleDataType[] = [
    { header: 'ID', value: 'Unique ID' },
    { header: 'Title', value: 'title' },
    { header: 'Subtitle', value: 'subtitle' },
    { header: 'Video Url', value: 'https://www.youtube.com/embed/XKwmoLKUU0s' },
    { header: 'Published', value: '0 or 1' },
    { header: 'Order', value: '5' },
    { header: 'Tags', value: 'tag1, tag2' },
]

export const validationSchema = Yup.array().of(
    Yup.object().shape({
        externalId: validation.excelExternalId,
        title: Yup.string().required(),
        subtitle: Yup.string().required(),
        published: validation.excelBoolean,
        embeddedUrl: validation.videoEmbeddedUrl,
        order: Yup.number().typeError('Invalid number').min(0),
    })
)

export const importProps: Omit<ImportDataFormProps, 'onSubmit'> = {
    mappedFields,
    sampleData,
    sampleFile: SampleFile,
    validationSchema,
}

const DEFAULT_MOVIE_URL = 'https://www.youtube.com/embed/XKwmoLKUU0s'

export const handleSubmit = async (cinemaSpace, data, dispatch, callback) => {
    const submittedData = data.map((e) => ({
        ...e,
        published: convertBooleanValue(e.published),
        order: parseInt(e.order, 10) || 0,
        embeddedUrl: e.embeddedUrl || DEFAULT_MOVIE_URL,
        tags: convertStringToList(e.tags)
    }))

    let completed = 0
    let errorItems = []
    const chunked_data = chunk(submittedData, LIMITED_NUMBER_OF_UPLOADED_ITEMS)
    // eslint-disable-next-line no-restricted-syntax
    for (const _data of chunked_data) {
        // eslint-disable-next-line no-await-in-loop
        const response = await importMovies(cinemaSpace, _data)
        if (response.errors.length) {
            return dispatch(showErrorNotification(response.errors))
        }
        const importResult = response.data.importMovie
        completed += LIMITED_NUMBER_OF_UPLOADED_ITEMS
        errorItems = [...errorItems, ...importResult.errorItems.map((e) => e.id)]
        dispatch(
            setProgress({
                completed: Math.min(completed, submittedData.length),
                errorItems,
            })
        )
    }
    callback?.()
}
